import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: '/dev/generate-species-and-breeds',
    name: 'species-and-breeds-generator',
    component: () => import('./views/GenerateSpeciesAndBreeds.view.vue'),
  },
];
